var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames, formatNumberToPrecision } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useSpringValues } from '../hooks/use-spring-values';
import { isNumber } from 'lodash';
import { animated } from '@react-spring/web';
import { SvgTspan } from './svg-tspan';
var cls = classNames('svg-animated-count');
export var SvgAnimatedCountDefaultProps = {
  value: 100,
  fontWeight: 500,
  fontSize: 22,
  precision: 1,
  preserveWholeNumbers: true,
  from: {
    value: 0
  },
  colors: {
    fill: 'strong'
  },
  prefix: {
    fontWeight: 300,
    colors: {
      fill: 'canvas'
    }
  },
  suffix: {
    fontWeight: 300,
    colors: {
      fill: 'canvas'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var PrefixStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var SuffixStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SvgAnimatedCount',
  Container: styled.text(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Value: styled(animated(SvgTspan))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Suffix: styled(SvgTspan)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), SuffixStyles),
  Prefix: styled(SvgTspan)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), PrefixStyles)
};
export var SvgAnimatedCount = function (props) {
  var componentProps = useComponentProps(My.NAME, SvgAnimatedCountDefaultProps, props);
  var className = componentProps.className,
    x = componentProps.x,
    y = componentProps.y,
    colors = componentProps.colors,
    precision = componentProps.precision,
    preserveWholeNumbers = componentProps.preserveWholeNumbers,
    suffix = componentProps.suffix,
    prefix = componentProps.prefix,
    rest = __rest(componentProps, ["className", "x", "y", "colors", "precision", "preserveWholeNumbers", "suffix", "prefix"]);
  var value = useSpringValues(componentProps).value;
  var formatValue = props.formatValue || function (value) {
    return formatNumberToPrecision(value, precision, {
      preserveWholeNumbers: true
    });
  };
  var format = function (value) {
    return formatValue ? formatValue(value) : value.toFixed(0);
  };
  var suffixProps = __assign(__assign({}, rest), suffix);
  var prefixProps = __assign(__assign({}, rest), prefix);
  return React.createElement(My.Container, {
    dominantBaseline: "middle",
    textAnchor: "middle",
    x: x,
    y: y,
    className: cls.name(className)
  }, prefix.text && React.createElement(My.Prefix, __assign({}, prefixProps), prefix.text), React.createElement(My.Value, __assign({
    colors: colors
  }, rest), isNumber(value) ? value : value.to(format)), suffix.text && React.createElement(My.Suffix, __assign({}, suffixProps, {
    colors: suffix.colors
  }), suffix.text));
};
SvgAnimatedCount.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;